import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusesSection } from '../components/BonusesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { FaqSection } from '../components/FaqSection';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function Landing() {
  return <main className="min-h-screen bg-transparent" data-id="element-227">
      <HeroSection data-id="element-228" />
      <ProblemSection data-id="element-229" />
      <div className="cv-section" data-id="element-230">
        <SolutionSection data-id="element-231" />
      </div>
      <div className="cv-section" data-id="element-232">
        <FeaturesSection data-id="element-233" />
      </div>
      <div className="cv-section" data-id="element-234">
        <ModulesSection data-id="element-235" />
      </div>
      <div className="cv-section" data-id="element-236">
        <BonusesSection data-id="element-237" />
      </div>
      <div className="cv-section" data-id="element-238">
        <BenefitsSection data-id="element-239" />
      </div>
      <PricingSection data-id="element-240" />
      <div className="cv-section" data-id="element-241">
        <GuaranteeSection data-id="element-242" />
      </div>
      <div className="cv-section" data-id="element-243">
        <TestimonialsBottom data-id="element-244" />
      </div>
      <div className="cv-section" data-id="element-245">
        <FaqSection data-id="element-246" />
      </div>
      <div className="cv-section" data-id="element-247">
        <FinalPricingCTA data-id="element-248" />
      </div>
      <Footer data-id="element-249" />
      <StickyCTA data-id="element-250" />
    </main>;
}